import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { UserListComponent } from './list/user-list.component';
import { UserCreateComponent } from './create/user-create.component';
import { UserUpdateComponent } from './update/user-update.component';
import { UserResetComponent } from './reset/user-reset.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: UserListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'user.read'
            }
          }
        ]
      },
      {
        path: 'create',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Add User'
        },
        children: [
          {
            path: '',
            component: UserCreateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'user.create'
            }
          }
        ]
      },
      {
        path: ':id/update',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Update User'
        },
        children: [
          {
            path: '',
            component: UserUpdateComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'user.update'
            }
          }
        ]
      },
      {
        path: ':id/reset',
        component: BasePageComponent,
        data: {
          breadcrumb: 'Reset User'
        },
        children: [
          {
            path: '',
            component: UserResetComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'user.update'
            }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {}
